<template>
  <!-- Table Skeleton -->
  <div v-if="type === 'table'">
    <div class="table-responsive">
      <table class="card-table">
        <thead>
          <tr>
            <th v-for="n in columns" :key="n">
              <div class="skeleton-line" style="width: 70%; height: 14px;"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r">
            <td v-for="n in columns" :key="n">
              <div class="skeleton-line" :style="{ width: randomWidth() }"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Status Cards Skeleton -->
  <div v-else-if="type === 'cards'" class="row">
    <div class="col-md-3" v-for="n in count" :key="n">
      <div class="card flex-fill">
        <div class="card-body">
          <div class="skeleton-line" style="width: 50%; height: 12px; margin-bottom: 10px;"></div>
          <div class="skeleton-line" style="width: 70%; height: 22px; margin-bottom: 12px;"></div>
          <div class="skeleton-line" style="width: 100%; height: 5px; border-radius: 3px;"></div>
          <div class="skeleton-line" style="width: 40%; height: 12px; margin-top: 10px;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Form Skeleton -->
  <div v-else-if="type === 'form'">
    <div class="row g-3">
      <div :class="fieldClass" v-for="n in fields" :key="n">
        <div class="skeleton-line" style="width: 35%; height: 12px; margin-bottom: 8px;"></div>
        <div class="skeleton-line" style="width: 100%; height: 38px; border-radius: 6px;"></div>
      </div>
    </div>
  </div>

  <!-- Generic Line Skeleton -->
  <div v-else>
    <div class="skeleton-line mb-2" v-for="n in rows" :key="n" :style="{ width: randomWidth(), height: height }"></div>
  </div>
</template>

<script>
export default {
  name: 'AppSkeleton',
  props: {
    type: {
      type: String,
      default: 'line', // 'table', 'cards', 'form', 'line'
    },
    rows: {
      type: Number,
      default: 5,
    },
    columns: {
      type: Number,
      default: 6,
    },
    count: {
      type: Number,
      default: 4,
    },
    fields: {
      type: Number,
      default: 6,
    },
    fieldClass: {
      type: String,
      default: 'col-md-4',
    },
    height: {
      type: String,
      default: '14px',
    },
  },
  methods: {
    randomWidth() {
      const widths = ['55%', '65%', '75%', '85%', '45%', '90%'];
      return widths[Math.floor(Math.random() * widths.length)];
    },
  },
};
</script>

<style scoped>
.skeleton-line {
  background: linear-gradient(90deg, #e9ecef 25%, #f3f4f6 50%, #e9ecef 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  height: 14px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>